import React from "react";
import { Segment, Header, SemanticCOLORS } from "semantic-ui-react";
import InspectionSummaryComment, { InspectionSummaryCommentProps } from "./InspectionSummaryComment";
import InspectionStatusLabel from "../InspectionStatusLabel";
import { InspectionStatus, InspectionStatuses } from "../citizen-inspection-list/constants/InspectionStatus";

export interface CompletedInspectionSummaryProps {
  comments: InspectionSummaryCommentProps[];
  loading: boolean;
  status: string;
}
export default function CompletedInspectionSummary({ comments, loading, status }: CompletedInspectionSummaryProps) {
  const color: SemanticCOLORS | undefined =
    status === InspectionStatuses.PASSED ? "green" : status === InspectionStatuses.FAILED ? "red" : undefined;
  return (
    <Segment loading={loading} color={color}>
      <div>
        <Header className='tw-flex tw-justify-between'>
          Inspection Summary
          <InspectionStatusLabel status={status as InspectionStatus} />
        </Header>
        {comments.map((comment, index) => {
          return (
            <div key={index} className='tw-py-1'>
              <InspectionSummaryComment
                comment={comment.comment}
                completedAt={comment.completedAt}
                firstName={comment.firstName}
                lastName={comment.lastName}
              />
            </div>
          );
        })}
      </div>
    </Segment>
  );
}
